import stripProtocol from '../services/strip-protocol';

export default function memberUserMapper({ id, name, email = '', image, attributes = {} }) {
  return {
    siteMemberId: id,
    name: name || attributes.name || email.substring(0, email.indexOf('@')) || 'unknown',
    email,
    image: stripProtocol(image || attributes.imageUrl),
  };
}



// WEBPACK FOOTER //
// ./app/services/member-user-mapper.js